import { useLocalization, cn } from '@magicdoorinc/ui';
import { splitProps } from 'solid-js';
import type { JSX, ComponentProps } from 'solid-js';

interface LabelWithOptionalProps extends ComponentProps<'span'> {
  label: string | JSX.Element;
}

export const LabelWithOptional = (props: LabelWithOptionalProps) => {
  const { t } = useLocalization();
  const [local, others] = splitProps(props, ['label', 'class', 'children']);

  return (
    <span class={cn(local.class)} {...others}>
      {local.label} <span class="text-xs text-text-03">({t('Optional')})</span>
    </span>
  );
};
